import { getStudents } from '../Common/Database';

export async function getTeachersStudent(mail: string) {
  const studentsList = await getStudents();
  const studentsArr: any[] = [];

  if (studentsList) {
    const mapList = Object.values(studentsList);

    mapList.forEach(student => {
      if (student?.subjects) {
        const subjectsArr: any[] = [];
        Object.values(student.subjects).forEach(subject => {
          if (subject.activeSub && subject?.attachedTeacher?.id && subject.attachedTeacher.id === mail) {
            subjectsArr.push(subject);
          }
        });

        if (subjectsArr.length > 0) {
          studentsArr.push(student);
        }
      }
    });
  }

  return studentsArr;
}
